import coreAPIInstance from "./coreApiInstance";

export const segmentAPIs = {
  getSegmentsForStream: ({ payload }) => coreAPIInstance.get(`/api/v1/segments/${payload.streamId}`, payload),
  createSegment: ({ payload }) => coreAPIInstance.post("/api/v1/segments", payload),
  updateSegment: ({ payload }) => coreAPIInstance.patch(`/api/v1/segments/${payload.segmentId}`, payload),
  deleteSegment: ({ payload }) => coreAPIInstance.delete(`/api/v1/segments/${payload.segmentId}`, payload),
  mergeAndExportSegments: ({ payload }) => coreAPIInstance.post("/api/v1/segments/merge_and_export", payload),
};
